function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9995 14.4023C13.3235 14.4023 14.4028 13.3249 14.4028 12C14.4028 11.477 14.2317 10.9941 13.9485 10.5997C13.512 9.99453 12.8024 9.59769 12.001 9.59769C11.1991 9.59769 10.49 9.99405 10.0525 10.5992C9.76832 10.9936 9.59866 11.4765 9.59818 11.9995C9.59673 13.3244 10.6751 14.4023 11.9995 14.4023Z",
  fill: "#D0CADB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2455 9.06114V6.74775L14.9316 6.755L14.9394 9.06887L17.2455 9.06114Z",
  fill: "#D0CADB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.38323 0 0 5.38323 0 12C0 18.6163 5.38323 24 12 24C18.6163 24 24 18.6163 24 12C24 5.38323 18.6173 0 12 0ZM18.8246 16.1874C18.8246 17.6428 17.6413 18.8256 16.1869 18.8256H7.8131C6.35817 18.8256 5.17538 17.6428 5.17538 16.1874V7.81358C5.17538 6.35866 6.35817 5.17586 7.8131 5.17586H16.1864C17.6413 5.17586 18.8246 6.35866 18.8246 7.81358V16.1874Z",
  fill: "#D0CADB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7331 12C15.7331 14.0577 14.0587 15.733 12.0001 15.733C9.94141 15.733 8.26752 14.0577 8.26752 12C8.26752 11.505 8.36613 11.0318 8.54207 10.5997H6.50469V16.1874C6.50469 16.9095 7.09101 17.4944 7.81267 17.4944H16.186C16.9067 17.4944 17.494 16.9095 17.494 16.1874V10.5997H15.4556C15.633 11.0318 15.7331 11.505 15.7331 12Z",
  fill: "#D0CADB"
});

var SvgInstagramIcon = function SvgInstagramIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagramIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InstagramIcon.2b3d6d19.svg";
export { ForwardRef as ReactComponent };